import { useEffect, useState } from "react";
import Select from "react-select";
//----------------------------------------------------------
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import {
    MyFormData,
    myAxios
} from "src/components/common/functions";
//----------------------------------------------------------
export default function List({
    closeIt,  
    tabTitle, 
    history, 
    data, 
    setFleetList, 
    trucksMap
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const pathname = history.location.pathname + (history.location.hash ?? "");
    const id = pathname.split("/")[2];
    const action = pathname.split("/")[5];
    const [settingsData, setSettingsData] = useState({});
    const settingsDataArr = Object.entries(settingsData);
    const [yardsData, setYardsData] = useState({});
    const [copyKey, setCopyKey] = useState("");
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            //---------------------------------------------------------------------
            setShowLoader(true);
            const res1 = await myAxios("fleet/readInventory.php");
            if(!isMounted) return;
            setShowLoader(false);
            if(!res1) return;
            //---------------------------------------------------------------------
            setSettingsData(res1.data);
            setYardsData(JSON.parse(data || "{}"));
        }
        getData();
        return () => isMounted = false;
    }, []);
    return (
        <Modal
            closeIt = {closeIt}
            title = {id + " Inventory"}
            width = {"60%"}
            actionKey = "Save"
            handleFormSubmit = {async() => {
                // yardsData[yard].inventoryUpdateTime = new MyDate().s() + " " + new MyDate().ss();
                const formData = new MyFormData();
                formData.append("truckNumber", id);
                formData.append("inventory", JSON.stringify(yardsData));
                //---------------------------------------------------------------------
                setShowLoader(true);
                const res = await myAxios("fleet/updateFleetInventory.php", formData);
                setShowLoader(false);
                if(!res) return;
                //---------------------------------------------------------------------
                setFleetList(res.data);
                closeIt();
            }}
        >
            <div className = "d-flex align-items-center my-2">
                <label htmlFor = {"copy item"}>Copy from </label>
                <select
                    id = {"copy item"}
                    className = "ml-2 flex-grow-1 form-control"
                    value = {copyKey}
                    onChange = {e => {
                        const key = e.currentTarget.value;
                        setCopyKey(key);
                    }}
                >
                    <option value = {""}>Select</option>
                    {Object.keys(trucksMap).map(key => <option key = {key}>{key}</option>)}
                </select>
                {copyKey !== "" && JSON.stringify(trucksMap[copyKey]) !== JSON.stringify(yardsData)?
                <span className = "ml-2 btn btn-info" onClick = {() => {
                    if(JSON.stringify(yardsData) !== "{}" && !window.confirm("Are you sure to overwrite current data?")) return;
                    setYardsData(trucksMap[copyKey])
                }}>Confirm</span>
                :<></>}
            </div>
            <div className = "d-flex align-items-center my-2">
                <label htmlFor = "new item">Items</label>
                <Select
                    isMulti
                    inputId = "new item"
                    className = "ml-2 flex-grow-1"
                    options = {settingsDataArr.map(([key, {title, path, note }]) => ({
                        path, title, note,
                        label: title,
                        value: key
                    }))}
                    value = {
                        Object.entries(yardsData).map(
                            ([key, {qty, fleetItemNote}]) => 
                            ({
                                qty, fleetItemNote,
                                label: settingsData[key].title,
                                value: key
                            })
                        )
                    }
                    onChange = {e => {
                        const originArr = Object.entries(yardsData);
                        const arr = e?.map(({ value }) => 
                            originArr.some(entry => 
                                entry[0] === value
                            )?
                            originArr.find(entry => 
                                entry[0] === value
                            )
                            :
                            [value, {
                                qty: "",
                                fleetItemNote: ""
                            }]
                        );
                        setYardsData(Object.fromEntries(arr));
                    }}
                />
            </div>
            {Object.entries(yardsData).map(([key, renderedValue], index) => 
            <li className = "my-3 d-flex align-items-center" key = {index}>
                <label
                    htmlFor = {key + " item"}
                >
                    Item {index + 1}
                </label>
                {settingsData[key].path?
                <img
                    className = "ml-2 rounded"
                    src = {settingsData[key].path}
                    alt = ""
                    style = {{
                        width: 100, 
                        height: 100
                    }}
                />:
                <></>
                }
                <input
                    data-toggle = "tooltip"
                    title = {settingsData[key].note}
                    id = {key + " item"}
                    className = {`ml-2 form-control flex-grow-1 ${settingsData[key].note?"text-info":""}`}
                    readOnly
                    value = {settingsData[key].title}
                />
                    <label
                        className = "ml-2"
                        htmlFor = {key + " qty"}
                    >
                        Quantity
                    </label>
                <input
                    required
                    type = "number"
                    min = {0} id = {key + " qty"}
                    className = "form-control ml-2"
                    style = {{width: "100px"}}
                    value = {renderedValue.qty}
                    onChange = {e => {
                        const targetValue = e.currentTarget.value;
                        setYardsData(
                            {
                                ...yardsData, 
                                [key]: {
                                    ...yardsData[key],
                                    qty: targetValue
                                }
                            }
                        );
                    }}
                />
                <label className = "ml-2" htmlFor = {key + " fleetItemNote"}>Note</label>
                <input
                    id = {key + " fleetItemNote"}
                    className = {"ml-2 form-control flex-grow-1"}
                    value = {renderedValue.fleetItemNote}
                    onChange = {e => {
                        const targetValue = e.currentTarget.value;
                        setYardsData(
                            {
                                ...yardsData, 
                                [key]: {
                                    ...yardsData[key],
                                    fleetItemNote: targetValue
                                }
                            }
                        );
                    }}
                />
                <span>
                </span>
                <span>
                    <button type = "button" className = "btn btn-info ml-2" onClick = {() => {
                        history.push(`/${tabTitle}/${id}/List/${key}/order`);
                    }}>
                        ⇅
                    </button>
                    {action === "order"?
                    <Order
                        id = {key}
                        closeIt = {() => history.push(`/${tabTitle}/${id}/List`)}
                        setYardsData = {setYardsData}
                        yardsData = {yardsData}
                        settingsData = {settingsData}
                    />:<></>}
                </span>
            </li>)
            }
        </Modal>
    )
}

function Order({ id, yardsData, setYardsData, settingsData, closeIt }){
    const arr = Object.entries(yardsData).map((entry, index) =>([...entry, index]));
    const originIndex = arr.find(entry => entry[0] === id)[2];
    const [target, setTarget] = useState("");
    return(
        <Modal
            touchOutsideClose
            closeIt = {closeIt}
            title = {"Change Order of " + settingsData[id].title}
            width = {"60%"}
            onSave = {() => {
                const result = [];
                if(!target){
                    result.push([id, yardsData[id]], ...arr.filter(entry => entry[0] !== id));
                }else{
                    let targetIndex = -1;
                    for(let i = 0; i < arr.length; i++){
                        if(arr[i][0] === target){
                            targetIndex = i;
                        }
                    }
                    result.push(
                        ...arr.slice(0, targetIndex + 1).filter(entry => entry[0] !== id), 
                        [id, yardsData[id]],
                        ...arr.slice(targetIndex + 1).filter(entry => entry[0] !== id)
                    )
                }
                setYardsData(
                      Object.fromEntries(result)
                ); //*
                closeIt();
            }}
        >
            <div>
                <select
                    className = "form-control m-3"
                    value = {target}
                    onChange = {e => setTarget(e.currentTarget.value)}
                >
                    <option value = {""} disabled = {originIndex === 0}>
                        At the Top
                    </option>
                    {arr.map(([key, value], renderedIndex) => 
                    <option
                        disabled = {renderedIndex === originIndex || renderedIndex + 1 === originIndex}
                        key = {key}
                        value = {key}
                    >
                        After {settingsData[key].title}
                    </option>
                    )}
                </select>
            </div>
        </Modal>
    );
}